// src/shared/components/Layout.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from 'shared/components/Navbar';

// Layout component that includes the header
const Layout = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const landingpage = location.pathname === '/';

  return (
    <div className="h-screen flex flex-col bg-black">
      {/* Conditionally render navbar */}
      {!isLoginPage && !landingpage && <Navbar className="flex-none" />}
      {/* Main content that takes up all remaining space */}
      <main className="flex-1 overflow-hidden">
        {children}
      </main>
    </div>
  );
};

export default Layout;
